import React, {
  useState,
  useRef,
  useEffect,
  useContext,
  Fragment,
} from 'react';
import IntlMessages from 'util/IntlMessages';
import { Auth } from 'aws-amplify';
import Loading from 'util/loading';
import axios from 'axios';

import {
  Typography,
  List,
  ListItem,
  ListItemText,
  Switch,
  FormControl,
  InputLabel,
  MenuItem,
  Snackbar,
  Alert,
  Card,
  CardContent,
  Select,
} from '@mui/material';

import Context from './context';
import * as actions from './actions';

const styles = {
  card: {
    marginTop: 1,
    minHeight: 120,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  select: {
    minWidth: 320,
  },
};

const Item = () => {
  const { state, dispatch } = useContext(Context);
  const [currentOperatorId, setCurrentOperatorId] = useState('');
  const [currentOperatorResources, setCurrentOperatorResources] = useState([]);
  const [operatorsList, setOperatorsList] = useState([]);
  const [alert, setAlert] = useState('');

  const mounted = useRef(null);

  useEffect(() => {
    mounted.current = true;

    listOperators();

    return function cleanup() {
      mounted.current = false;
    };
  }, []);

  // busca a lista de operadores
  async function listOperators() {
    const url =
      'https://20arn6e6dj.execute-api.us-east-1.amazonaws.com/production/listoperators2?resource_id=urn:*';

    try {
      dispatch({ type: actions.LOADING, payload: true });
      const result = await axios.get(url);

      if (mounted.current) {
        setOperatorsList(result.data.sort(compare));
      }
    } catch (error) {
      console.log(error);
      setAlert(error.message);
    } finally {
      if (mounted.current) {
        dispatch({ type: actions.LOADING, payload: false });
      }
    }
  }

  function compare(a, b) {
    // decrescente
    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    if (b.name.toLowerCase() > a.name.toLowerCase()) return -1;

    return 0;
  }

  // tenta atualizar (ou adicionar) uma URN
  async function changeResource(aUrn, aEnabled) {
    try {
      let authToken = (await Auth.currentSession()).getIdToken().getJwtToken();
      let url =
        'https://20arn6e6dj.execute-api.us-east-1.amazonaws.com/production/updateresource';

      var options = {
        url: url,
        method: 'post',
        headers: {
          Authorization: 'Bearer ' + authToken,
        },
        data: {
          operator_id: currentOperatorId,
          resource_id: aUrn,
          value: aEnabled,
        },
      };

      dispatch({ type: actions.LOADING, payload: true });
      let result = await axios(options);

      // jeito feio: ele lista novamente todos os provedores, para atualizar as urns apenas do selecionado
      await listOperators();
    } catch (error) {
      console.log(error);
      setAlert(error.message);
    } finally {
      dispatch({ type: actions.LOADING, payload: false });
      // dispatch({ type: actions.SHOW_DIALOG, payload: false });
    }
  }

  // busca as informações do provedor selecionado, para atualizar a lista de recursos (urns)
  useEffect(() => {
    async function updateResources() {
      if (currentOperatorId === '') {
        return;
      }

      const url =
        'https://20arn6e6dj.execute-api.us-east-1.amazonaws.com/production/getOperatorResources?idp=' +
        currentOperatorId;

      console.log(url);

      try {
        dispatch({ type: actions.LOADING, payload: true });
        const result = await axios.get(url);

        if (mounted.current && 'data' in result) {
          setCurrentOperatorResources(result.data);
        }
      } catch (error) {
        console.log(error);
        setAlert(error.message);
      } finally {
        if (mounted.current) {
          dispatch({ type: actions.LOADING, payload: false });
        }
      }
    }

    updateResources();
  }, [currentOperatorId]);

  // muda o provedor selecionado
  function handleChangeOperator(aEvent) {
    console.log('selecionou ', aEvent.target.value);
    setCurrentOperatorId(aEvent.target.value);
  }

  function handleCloseAlert() {
    setAlert('');
  }

  return (
    <Fragment>
      <Loading loading={Boolean(state.loading)} />

      <Snackbar
        open={alert.length > 0}
        autoHideDuration={4000}
        onClose={(e) => handleCloseAlert()}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Alert severity="error">{alert}</Alert>
      </Snackbar>

      <Typography variant="h6" align="left">
        <IntlMessages id="neo.gateway.resources" />
      </Typography>

      {/* Lista de provedores */}
      <Card sx={styles.card}>
        <CardContent>
          <FormControl required variant="standard">
            <InputLabel>
              <IntlMessages id="neo.operators.single" />
            </InputLabel>

            <Select
              name="currentOperator"
              value={currentOperatorId}
              onChange={handleChangeOperator}
              variant="standard"
              sx={styles.select}
            >
              {operatorsList.map((op, idx) => (
                <MenuItem key={idx} value={op.id}>
                  {op.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </CardContent>
      </Card>

      {/* Lista de recursos do provedor selecionado */}
      <Card sx={styles.card}>
        <CardContent>
          <List>
            {currentOperatorResources.map((resource) => (
              <ListItem
                key={resource.urn}
                sx={{ width: '340px' }}
                secondaryAction={
                  <Switch
                    color="primary"
                    checked={resource.enabled}
                    disabled={true}
                  />
                }
              >
                <ListItemText primary={resource.urn} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    </Fragment>
  );
};

export default Item;
